import { EventListenerArgs, EventPath, ListenerFunction } from './types'

const registeredEvents = new Map<string, Set<ListenerFunction>>();

const getEventKey = ({ domain, serviceName, eventName }: EventPath) => `${domain}:${serviceName}:${eventName}`;

export function getListeners(path: EventPath): Set<ListenerFunction> {
    const key = getEventKey(path);
    return registeredEvents.get(key) || new Set<ListenerFunction>();
}

export function addListener({ listener, ...eventPath }: EventListenerArgs): void {
    const key = getEventKey(eventPath);
    const eventListeners = registeredEvents.get(key);

    if (eventListeners) {
        eventListeners.add(listener);
    } else {
        registeredEvents.set(key, new Set([listener]));
    }
}

export function removeListener({ listener, ...eventPath }: EventListenerArgs): void {
    const key = getEventKey(eventPath);
    const eventListeners = registeredEvents.get(key);
    if (eventListeners) {
        eventListeners.delete(listener);
    }
}
